import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startAtTime", "numberOfAppointments", "endAt"]
  static values = { duration: Number }

  connect () {
    this.updateEndAt()
  }

  updateEndAt () {
    const startAt = this.startAtTimeTarget.value
    const count = parseInt(this.numberOfAppointmentsTarget.value, 10)

    if (!startAt || Number.isNaN(count) || !this.durationValue) {
      this.endAtTarget.value = ""
      return
    }

    const [hours, minutes] = startAt.split(":").map(Number)
    const totalMinutes = hours * 60 + minutes + count * this.durationValue
    const endHours = Math.floor(totalMinutes / 60) % 24
    const endMinutes = totalMinutes % 60

    this.endAtTarget.value = `${String(endHours).padStart(2, "0")}:${String(endMinutes).padStart(2, "0")}`
  }
}
